import { CustomDialog } from "@/components/ui-elements";
import { useCloneWorkflow } from "@/features/workflow/api/cloneWorkflow";
import useWorkflowStore from "@/store/workflow/workflowStore";
import type { ForwardRefRenderFunction } from "react";
import { forwardRef, useCallback } from "react";

interface CloneGroupPopupProps {
  workflow_id: string | undefined;
  workflow_label: string;
}

const CloneGroupPopupComponent: ForwardRefRenderFunction<
  HTMLDivElement,
  CloneGroupPopupProps
> = ({ workflow_id, workflow_label }) => {
  const { isCloneGroupPopupOpen, closeCloneGroupPopup } = useWorkflowStore();
  const cloneWorkflowMutation = useCloneWorkflow();

  const handleClone = useCallback(async () => {
    if (!workflow_id) {
      return;
    }

    try {
      await cloneWorkflowMutation.mutateAsync({
        workflow_id,
        workflow_label: `${workflow_label}のコピー`,
      });
      closeCloneGroupPopup();
    } catch (error) {
      // Error handling
    }
  }, [
    workflow_id,
    workflow_label,
    cloneWorkflowMutation,
    closeCloneGroupPopup,
  ]);

  return (
    <CustomDialog
      open={isCloneGroupPopupOpen}
      onClose={closeCloneGroupPopup}
      title={`Scan設定「${workflow_label}」を複製`}
      description={`Scan設定「${workflow_label}」の複製を実行します。よろしいですか？`}
      primaryButtonText="実行する"
      primaryButtonAction={handleClone}
      secondaryButtonText="キャンセル"
      secondaryButtonAction={closeCloneGroupPopup}
    />
  );
};

export const CloneGroupPopup = forwardRef(CloneGroupPopupComponent);
CloneGroupPopup.displayName = "CloneGroupPopup";
